@if(show()){
<div id="spinner" loading-widget class="admin-loading-widget">
    <img class="show-on-light" src="./assets/images/lucide/loader.svg" alt="" width="48" height="48">
</div>
}